$(document).on("click", "#cart_remove_item", function(event){
        event.preventDefault();
        
          var removeitem = $(this).attr("data-id");
          var p_sku = $(this).parents('.cart-item').attr('data-sku');
          var cartCount = $(this).parents('.cart-drawer ').find('.cart_item_count');
 var find_mono = cart_drawer.$data.cart_items.find(itm => itm.properties["SKU"] == p_sku);
          var remove_item = {};
          remove_item[removeitem] = 0;
          if(find_mono){
            remove_item[find_mono.id]=0;
          }
        
          cart_drawer.$data.cart_open = true;
          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            dataType: "json",
            data: {updates: remove_item},
            success:function(){
              jQuery.getJSON("/cart.js", function(cart){
                cart_drawer.$data.cart_items = cart.items;
                cartCount.text(cart.item_count);
                     
              }); 
            }
          })
         });

//    $(document).on("click",'.product-form--atc-button',function(e) {

//     e.preventDefault();
//     var mf = [];
//     var st = $(this).parents('form[data-product-form]').find('.variant-selection');
//     console.log(st);
//      var variantId = st.attr('variant');
//       mf.push({
//                 id: variantId,
//                 quantity: 1
//             });
//  $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: { items: mf },
//         dataType: 'json',
//          success: function (cart) {
//         fetch('/cart.js')
//             .then(response => response.json())
//             .then(updatedCart => {
//                $('.mycart .cart_item_count').html('('+updatedCart.item_count+')')
//                 cart_drawer.$data.cart_items = updatedCart.items;
//                 cart_drawer.$data.cart_open = true;
//          })
//             .catch(error => {
//                 console.error('Error fetching cart data:', error);
//             });
//     }
//     });
// });
    
$(document).on('click', '[data-product-atc]', function(){
  event.preventDefault();
  event.stopPropagation();
  var formData = $(this).parents('form').serialize();
  formData = formData+'&properties[__extra_tag]='+$(this).attr('extra_tag')+'&properties[__cart_tag]='+$(this).attr('cart_tag');
  console.log(formData)
  // formData.append("properties[__extra_tag]", $(this).attr('extra_tag'));
  // formData.append("properties[__cart_tag]", $(this).attr('cart_tag'));
   $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
       success: function (cart) {
          fetch('/cart.js')
              .then(response => response.json())
              .then(updatedCart => {
                  console.log(updatedCart, "updatedCart");
               $('.mycart .cart_item_count').text('('+updatedCart.item_count+')')
              $('.site-header-cart--count[data-header-cart-count]').attr('data-header-cart-count', updatedCart.item_count)
                  // Update the cart_items and open the cart drawer
                  cart_drawer.$data.cart_items = updatedCart.items;
                  cart_drawer.$data.cart_open = true;
              })
              .catch(error => {
                  console.error('Error fetching cart data:', error);
              });
      }
    });
})
// $(document).on("click",'.productitem--action-atc:not([data-quickshop-slim])',function(e) {

//     e.preventDefault();
//     var mf = [];
//     var st = $(this).attr('data-variant-id')
//     console.log(st);
//      mf.push({
//                 id:st,
//                 quantity: 1
//             });

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: { items: mf },
//         dataType: 'json',
//        success: function (cart) {
//         fetch('/cart.js')
//             .then(response => response.json())
//             .then(updatedCart => {
//                 console.log(updatedCart, "updatedCart");
//              $('.mycart .cart_item_count').text('('+updatedCart.item_count+')')
//                 // Update the cart_items and open the cart drawer
//                 cart_drawer.$data.cart_items = updatedCart.items;
//                 cart_drawer.$data.cart_open = true;
//             })
//             .catch(error => {
//                 console.error('Error fetching cart data:', error);
//             });
//     }
   
//     });
// });


// sticky button product
$(document).on('click','.sticky_cart_btn',function(){
    $('.product-form--atc-button').click();

});
$(document).ready(function() {
  $('.cloudtext_drawer').each(function(){
      var suffix = $(this).attr('extra_tag').match(/\d+/);
       console.log(suffix)
      if(suffix != null){
          var tot = $(this).attr('qty') / suffix;
          if($(this).attr('cart_tag')){
            var cart_tag = $(this).attr('cart_tag');
          }else{
            var cart_tag = '';
          }
          var somestr = "Note: "+$(this).attr('qty')+" = " + tot + " " + cart_tag;
         
         //alert(somestr);
        $(this).html(somestr);
       }
  })
  if($('body').hasClass('template-product')){
     $('.product__sticky_box').hide();
      var $addToCartButton = $('.product-form--atc-button');
      var initialPosition = $addToCartButton.offset().top;
    
      $(window).scroll(function() {
      var scrollPosition = $(window).scrollTop();
      
        if (scrollPosition > initialPosition) {
            $('.product__sticky_box').show()
        } else {
         $('.product__sticky_box').hide();
         }
      }); 
  }
});
 